import { Controller } from "@stimulus/core";

export default class extends Controller {
  static targets = ["scrollRight", "scrollLeft", "products"];

  initialize() {
    const rightScroll = this.scrollRightTarget;
    const leftScroll = this.scrollLeftTarget;
    const productWrap = this.productsTarget;

    const cardWidth =
      productWrap.querySelector(".product-card")?.getBoundingClientRect()
        .width + 15 || 345;

    rightScroll.addEventListener("click", () => {
      productWrap.scrollLeft += cardWidth;
    });

    leftScroll.addEventListener("click", () => {
      productWrap.scrollLeft -= cardWidth;
    });
  }
}
